import objectFitImages from 'object-fit-images'

$(function () {
  objectFitImages('.of-image')
})
